import { ROLES, type Role } from '../types/roles';

const USERS_PREFIX = 'Usuarios.';

const LEGACY_ROLE_MAP: Readonly<Record<string, Role>> = {
  SecretariaEjecutiva: ROLES.Secretaria_Ejecutiva,
  Secretaria_Ejecutiva: ROLES.Secretaria_Ejecutiva,
  SecretariaOficina: ROLES.Secretaria_Oficina,
  Secretaria_Oficina: ROLES.Secretaria_Oficina,
  TitularJER: ROLES.Titular,
  TitularJer: ROLES.Titular,
  DDISPE: ROLES.Titular,
  Ddispe: ROLES.Titular,
  EmpleadoSE: ROLES.Empleado,
  EmpleadoJER: ROLES.Empleado,
};

/**
 * Normaliza un rol a su forma canónica.
 * - Remueve prefijo `Usuarios.` si existe.
 * - Convierte variantes legacy conocidas a roles canónicos.
 */
export function normalizeRole(role: string): string {
  const trimmed = (role ?? '').trim();
  if (!trimmed) return '';

  const withoutPrefix = trimmed.startsWith(USERS_PREFIX)
    ? trimmed.slice(USERS_PREFIX.length)
    : trimmed;

  return LEGACY_ROLE_MAP[withoutPrefix] ?? withoutPrefix;
}

/**
 * Normaliza una lista de roles:
 * - Aplica normalización individual.
 * - Elimina vacíos.
 * - Elimina duplicados preservando orden.
 */
export function normalizeRoles(roles: ReadonlyArray<string>): string[] {
  const out: string[] = [];
  const seen = new Set<string>();

  for (const raw of roles ?? []) {
    const normalized = normalizeRole(raw);
    if (!normalized) continue;
    if (seen.has(normalized)) continue;
    seen.add(normalized);
    out.push(normalized);
  }

  return out;
}
